export enum DRAGGABLE_ITEM_TYPES {
  NEW_ITEM = 'new-item',
  EXIST_ITEM = 'exist-item'
}
export enum CostPerUnit {
  COUNT = 'count',
  KG = 'kg',
}
export enum MOTOR_STATUS {
  OFF = 0,
  ON = 1,
  OUT_OF_SERVICE = 2
}

export enum DIRECTION {
  TOP = 'top',
  RIGHT = 'right',
  BOTTOM = 'bottom',
  LEFT = 'left',
  TOP_RIGHT = 'topRight',
  TOP_LEFT = 'topLeft',
  BOTTOM_RIGHT = 'bottomRight',
  BOTTOM_LEFT = 'bottomLeft'
}
